import { TableProperties } from "PFApp/components/table_properties/table_properties";
import { Button } from "PFComponents/button";
import SidePanel from "PFComponents/side_panel/side_panel";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useProfilesPageContext } from "../../context";
import { useProfilesColumns } from "../../hooks/use_profiles_columns";

export const ProfilesTableProperties = () => {
  const { t } = useTranslation("profiles", { keyPrefix: "list.table" });
  const [isOpen, setIsOpen] = useState(false);

  const { selectedColumns, setSelectedColumns } = useProfilesPageContext();
  const { defaultColumns, customFieldsColumns } = useProfilesColumns();

  return (
    <>
      <Button
        icon="table"
        kind="secondary"
        onClick={() => setIsOpen(true)}
        title={t("openTableProperties")}
      />
      <SidePanel show={isOpen} fullHeight onClose={() => setIsOpen(false)} title={t("tableProperties")}>
        <TableProperties
          selectedColumns={selectedColumns}
          onColumnsChange={setSelectedColumns}
          availableColumns={defaultColumns.concat(customFieldsColumns)}
        />
      </SidePanel>
    </>
  );
};
